export default __webpack_public_path__ + "static/media/InactiveBucket.cd2f513d.svg";